import { boolean, object, string } from 'yup'

const ContactUsDealerSchema = object().shape({
  title: string().trim(),
  first_name: string()
    .required('First name is required')
    .matches(
      /^[A-Za-z-.,'` ]{1,50}$/,
      'First name can only contain letters and basic punctuation',
    )
    .min(2, 'First name must be at least 2 characters')
    .max(50, 'First name must be at most 50 characters')
    .trim(),
  last_name: string()
    .required('Last name is required')
    .matches(
      /^[A-Za-z-.,'` ]{1,50}$/,
      'Last name can only contain letters and basic punctuation',
    )
    .min(2, 'Last name must be at least 2 characters')
    .max(50, 'Last name must be at most 50 characters')
    .trim(),
  email: string()
    .required('Email is required')
    .matches(
      /^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/,
      'Email must be a valid email address',
    )
    .max(255)
    .trim(),
  tel: string()
    .matches(/^\d{7,11}$/, {
      message: 'Please enter a valid telephone number',
      excludeEmptyString: true,
    })
    .trim(),
  dealer: string().required('Please select an option'),
  type_dropdown: string().required('Please select an option'),
  reg_num: string().when('type_dropdown', {
    is: (value) =>
      ['servicing', 'notlisted_current', 'parts', 'repair'].includes(value),
    then: (rule) =>
      rule
        .trim()
        .matches(
          /(^[a-zA-Z]{2}[0-9]{2}\s?[a-zA-Z]{3}$)|(^[a-zA-Z][0-9]{1,3}[a-zA-Z]{3}$)|(^[a-zA-Z]{3}[0-9]{1,3}[a-zA-Z]$)|(^[0-9]{1,4}[a-zA-Z]{1,2}$)|(^[0-9]{1,3}[a-zA-Z]{1,3}$)|(^[a-zA-Z]{1,2}[0-9]{1,4}$)|(^[a-zA-Z]{1,3}[0-9]{1,3}$)|(^[a-zA-Z]{1,3}[0-9]{1,4}$)|(^[0-9]{3}[DX]{1}[0-9]{3}$)/,
          {
            message: 'Registration number is invalid',
            excludeEmptyString: true,
          },
        ),
  }),
  model: string().when(['type_dropdown'], {
    is: (type) => type === 'new_car',
    then: (rule) => rule.required('Please select a model'),
  }),
  comment: string().trim(),
  event: string().trim(),
  consent: object({
    user: boolean(),
  }),
})

export default ContactUsDealerSchema
